import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function cssBaseline(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
          ...(isDark && {
            scrollbarWidth: 'thin',
            scrollbarColor: `${alpha(theme.palette.grey[600], 0.48)} transparent`,
            '&::-webkit-scrollbar': {
              width: 8,
              height: 8,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: alpha(theme.palette.grey[600], 0.48),
              borderRadius: 4,
              '&:hover': {
                backgroundColor: alpha(theme.palette.grey[500], 0.72),
              },
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-corner': {
              backgroundColor: 'transparent',
            },
          }),
        },
        '*:focus': {
          outline: 'none',
        },
        '*:focus-visible': {
          outline: 'none',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          transition: 'background-color 0.15s ease, color 0.15s ease',
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
          transition: 'background-color 0.15s ease, color 0.15s ease',
        },
        // 다크모드 <-> 라이트모드 전환 시 화면 전체가 한 번에 부드럽고 자연스럽게 바뀌도록 주요 표면 및 텍스트 전환 속성 동기화
        '.MuiPaper-root, .MuiCard-root, .MuiAppBar-root, .MuiDrawer-paper': {
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease',
        },
        '.MuiTableCell-root, .MuiDivider-root': {
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease',
        },
        '.MuiButtonBase-root': {
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease',
        },
        '.MuiInputBase-root, .MuiOutlinedInput-root': {
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease',
        },
        '.MuiTypography-root': {
          transition: 'color 0.15s ease',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
  };
}
